export default "__VITE_ASSET__DZxd913j__"